export const SOCIAL_NAME_SAVE = 'SOCIAL_NAME_SAVE';
